module.exports = __webpack_public_path__ + "static/media/loc6_img4.b4ad6e0f.jpg";